Object.defineProperty(exports, "__esModule", { value: true });
exports.register = void 0;
const transforms_1 = require("../utils/transforms");
const shared = require("@volar/shared");
function register(languageService, getTextDocument) {
    return (uri, position) => {
        const document = getTextDocument(uri);
        if (!document)
            return [];
        const fileName = shared.uriToFileName(document.uri);
        const offset = document.offsetAt(position);
        let info;
        try {
            info = languageService.getDefinitionAndBoundSpan(fileName, offset);
        }
        catch (_a) { }
        if (!info)
            return [];
        return (0, transforms_1.boundSpanToLocationLinks)(info, document, getTextDocument);
    };
}
exports.register = register;
//# sourceMappingURL=definition.js.map